import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
`;

export const PropertyInfoContainer = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .card-body {
    width: 100%;
    position: relative;
    display:flex;
    flex-direction: column;
    gap:24px;
  }

  .policies {
    position: relative;

    li {
        position:relative;
        left:13px;
    }
  }

  .terms {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 170px;

    div {
        overflow: hidden;
        text-overflow: ellipsis;
    }
  }

  .unset {
    height:unset !important;
  }

  .gallery {

  }

  .title {
    position: relative;
  }

  .info-body {
    position: relative;
  }

  .btn-show-more {
    display: block;
  }
`;
